import { SEEKER_PROFILE_API_PATH } from "@/constants/appConstants";
import { FOOTER_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { GetFooterProps } from "./types";

export const fetchFooterData = async <T>(): Promise<T | Error> => {
  try {
    const response = await fetch(`${SEEKER_PROFILE_API_PATH}/footer`, {
      method: "GET",
      credentials: "include",
    });

    const data: T = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const getFooterData = (): UseQueryResult<GetFooterProps, Error> => {
  return useQuery({
    queryKey: [FOOTER_QUERY_KEY],
    queryFn: () => fetchFooterData(),
  });
};
